import React from "react";
import { Sparkles, Compass, Heart } from "lucide-react";
import { galleryDetails } from "../mock";
import Reveal from "./Reveal";

const Overview = () => {
  return (
    <section id="overview" className="section bg-paper relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <Reveal>
          <div className="relative h-[520px]">
            <div
              className="absolute top-0 left-0 w-[62%] h-[62%] bg-cover bg-center rounded-sm shadow-2xl"
              style={{ backgroundImage: `url(${galleryDetails[0]})` }}
            />
            <div
              className="absolute bottom-0 right-0 w-[58%] h-[60%] bg-cover bg-center rounded-sm shadow-2xl border-4 border-[#faf5ec]"
              style={{ backgroundImage: `url(${galleryDetails[1]})` }}
            />
            <div className="absolute -top-6 -left-6 w-24 h-24 border border-[#c9a55c]/50 rounded-sm z-[-1]" />
            <div className="absolute -bottom-6 -right-6 w-24 h-24 border border-[#1a3a2e]/30 rounded-sm z-[-1]" />
          </div>
        </Reveal>

        <Reveal delay={150}>
          <div>
            <span className="font-script text-[#c9a55c] text-3xl block mb-2">a winter story</span>
            <h2 className="font-display text-[#1a3a2e] text-4xl md:text-5xl leading-tight mb-6">
              Ten days of mulled wine,
              <em className="font-display italic text-[#c9a55c]"> twinkling lights</em>
              <br />and shared wonder.
            </h2>
            <div className="divider mb-6">
              <Sparkles className="w-4 h-4" strokeWidth={1.5} />
            </div>
            <p className="text-[#3b463f] leading-relaxed mb-5 font-light text-[15.5px]">
              Step into the heart of Europe&rsquo;s most magical holiday celebrations on this 10-day journey through England, Belgium, and France. Whether you bring your mother, daughter, sister, niece, or best friend, this festive adventure is designed for unforgettable shared memories.
            </p>
            <p className="text-[#3b463f] leading-relaxed mb-8 font-light text-[15.5px]">
              From the dazzling lights of London&rsquo;s West End to the storybook beauty of Bruges and the timeless elegance of Paris, this experience immerses you in the very best of Europe&rsquo;s Christmas spirit.
            </p>

            <div className="grid sm:grid-cols-2 gap-4 pt-2">
              <div className="flex items-start gap-3">
                <Compass className="w-5 h-5 text-[#c9a55c] mt-1 shrink-0" strokeWidth={1.5} />
                <div>
                  <h4 className="font-display text-[#1a3a2e] text-lg">5 Iconic Cities</h4>
                  <p className="text-[#3b463f]/80 text-sm">London, Brussels, Bruges, Paris, Strasbourg.</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Heart className="w-5 h-5 text-[#c9a55c] mt-1 shrink-0" strokeWidth={1.5} />
                <div>
                  <h4 className="font-display text-[#1a3a2e] text-lg">Ladies-Only</h4>
                  <p className="text-[#3b463f]/80 text-sm">An intimate small-group experience.</p>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Overview;
